// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M13.0003 2L13.0003 22H11.0003L11.0003 2L13.0003 2ZM9.0003 4.64087V18.5H1.30078L9.0003 4.64087ZM15.0003 4.64087L22.6998 18.5H15.0003V4.64087ZM4.69981 16.5H7.0003V12.3591L4.69981 16.5ZM17.0003 12.3591V16.5H19.3008L17.0003 12.3591Z"}}]};

const MirrorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mirror',
    ref,
    icon: element,
  },
));

MirrorIcon.displayName = 'MirrorIcon';

export default MirrorIcon;
